<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat color="transparent" class="rounded">
        <v-card-title class="mb-0">
          <v-icon>mdi-account-group-outline</v-icon>
          <h4 class="headline halfwhite-text ml-2">Manage Team</h4>
          <!-- <v-flex ml-2>
            <v-btn icon @click.stop="loadMemberList()" :disabled="isLoading">
              <v-icon title="Refresh" color="secondary">mdi-refresh</v-icon>
            </v-btn>
          </v-flex> -->
          <v-spacer></v-spacer>
          <v-flex xs4 text-xs-right pr-2>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              outline
              hide-details
              @click:clear="clearSearch"
            ></v-text-field>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-list three-line dense class="rounded list-bg-transparent">
            <v-flex v-if="isLoading" mb-2>
              <v-card color="white" class="rounded elevation-0">
                <v-card-text>
                  <div class="m-3">
                    <v-progress-linear
                      color="#d13b55"
                      height="2"
                      :indeterminate="true"
                    ></v-progress-linear>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex v-if="!isLoading && orgMembers.length == 0">
              <v-card color="white" class="rounded" elevation="0">
                <v-card-text>
                  <div class="m-3">
                    There is no member in the organization yet, send
                    <router-link :to="'/manageinvites'">invite</router-link> to
                    get started.
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex
              v-else
              v-for="(orgMember, index) in filteredItems"
              :key="index"
            >
              <v-card
                elevation="0"
                color="white"
                class="light-shadow rounded mb-3"
                :key="index"
              >
                <v-list-tile avatar ripple :key="index">
                  <v-list-tile-avatar
                    color="primary"
                    :title="
                      orgMember.firstname +
                      ' ' +
                      orgMember.lastname +
                      ' (' +
                      (orgMember.orgName
                        ? orgMember.orgName
                        : orgMember.subdomain) +
                      ')'
                    "
                  >
                    <img
                      v-if="orgMember.isavatarlocal"
                      :src="orgMember.avatarlocal"
                    />
                    <span style="padding: 11px" v-else class="white--text">{{
                      orgMember.firstname.charAt(0).toUpperCase() +
                      orgMember.lastname.charAt(0).toUpperCase()
                    }}</span>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span class="font-weight-medium subheading">{{
                        orgMember.firstname + " " + orgMember.lastname
                      }}</span>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ orgMember.email }}
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title>
                      <span class="font-weight-medium">
                        {{
                          orgMember.orgName
                            ? orgMember.orgName
                            : orgMember.subdomain
                        }}
                      </span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <!-- <template
                    v-if="
                      orgMember.isSuperAdmin &&
                      $store.getters.userIsAdministrative
                    "
                  >
                    <v-list-tile-action title="Application SuperAdmin">
                      <v-icon color="success">mdi-shield-account</v-icon>
                    </v-list-tile-action>
                  </template>

                  <template
                    v-else-if="
                      orgMember.isAdmin &&
                      $store.getters.userIsAdministrativeOrOrgOwner
                    "
                  >
                    <v-list-tile-action title="Application Admin">
                      <v-icon color="success">mdi-home-lock</v-icon>
                    </v-list-tile-action>
                  </template> -->

                  <template
                    v-if="$store.getters.isHRManager && orgMember.isParentOrg"
                  >
                    <div class="d-flex hidden-sm-and-down">
                      <v-list-tile-action>
                        <v-text-field
                          class="shrink"
                          style="width: 80px"
                          append-icon="mdi-content-save"
                          @click:append="saveMemberBirthDate(orgMember)"
                          v-model="orgMember.dateofbirth"
                          label="DoB"
                          hint="MM/DD format"
                        ></v-text-field>
                      </v-list-tile-action>

                      <v-list-tile-action>
                        <v-text-field
                          class="shrink mx-4"
                          style="width: 115px"
                          append-icon="mdi-content-save"
                          @click:append="saveMemberStartDate(orgMember)"
                          v-model="orgMember.startdate"
                          label="Start Date"
                          hint="MM/DD/YYYY format"
                        ></v-text-field>
                      </v-list-tile-action>

                      <v-list-tile-action>
                        <v-select
                          append-icon="mdi-content-save"
                          @click:append="saveMemberCountry(orgMember)"
                          class="shrink"
                          v-model="orgMember.country"
                          :items="countryList"
                          item-text="text"
                          item-value="value"
                          label="Country"
                          placeholder="Country"
                          :rules="requiredRules"
                          style="width: 115px"
                        ></v-select>
                      </v-list-tile-action>
                    </div>
                  </template>

                  <template
                    v-if="
                      $store.getters.userIsAdministrativeOrOrgOwner &&
                      orgMember.nameidentifier !==
                        ($store.state.userSelf.profile || {}).nameidentifier
                    "
                  >
                    <v-list-tile-action
                      v-if="orgMember.isOrgAdmin"
                      title="Organization Admin"
                    >
                      <v-icon color="success">mdi-home-lock</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-action
                      title="Remove Organization Owner Status"
                      v-if="$store.getters.isSuperAdmin && orgMember.isOwner"
                    >
                      <v-btn
                        icon
                        @click.stop="changeOrgOwnerStatus(orgMember, false)"
                      >
                        <v-icon color="red">mdi-home-minus</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-action
                      title="Remove Organization Owner Status"
                      v-else-if="orgMember.isOwner && !orgMember.isOrgAdmin"
                    >
                      <v-btn
                        icon
                        @click.stop="changeOrgOwnerStatus(orgMember, false)"
                      >
                        <v-icon color="red">mdi-home-minus</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-action
                      title="Add Organization Owner Status"
                      v-if="!orgMember.isOwner && !orgMember.isOrgAdmin"
                    >
                      <v-btn
                        icon
                        @click.stop="changeOrgOwnerStatus(orgMember, true)"
                      >
                        <v-icon color="secondary lighten-2"
                          >mdi-home-plus</v-icon
                        >
                      </v-btn>
                    </v-list-tile-action>
                  </template>
                  <template v-else>
                    <v-list-tile-action
                      v-if="orgMember.isOrgAdmin"
                      title="Organization Admin"
                    >
                      <v-icon color="success">mdi-home-lock</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-action
                      v-else-if="orgMember.isOwner && !orgMember.isOrgAdmin"
                      title="Organization Owner"
                    >
                      <v-icon color="primary">mdi-home-account</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-action v-else></v-list-tile-action>
                  </template>

                  <template
                    v-if="
                      ($store.getters.userIsAdministrative ||
                        $store.getters.isOrgAdmin) &&
                      !$store.getters.isCurrentOrgChild
                    "
                  >
                    <v-list-tile-action
                      title="Remove HR Manager Status"
                      v-if="orgMember.isHRManager"
                    >
                      <v-btn
                        icon
                        @click.stop="changeOrgHRManagerStatus(orgMember, false)"
                      >
                        <v-icon color="red">mdi-account-minus</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-action
                      title="Add HR Manager Status"
                      v-else-if="!orgMember.isHRManager"
                    >
                      <v-btn
                        icon
                        @click.stop="changeOrgHRManagerStatus(orgMember, true)"
                      >
                        <v-icon color="indigo">mdi-account-plus</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </template>
                  <template v-else>
                    <v-list-tile-action
                      v-if="orgMember.isHRManager"
                      title="HR Manager"
                    >
                      <v-icon color="indigo">mdi-account</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-action v-else></v-list-tile-action>
                  </template>

                  <template>
                    <v-list-tile-action
                      v-if="
                        $store.getters.userIsAdministrativeOrOrgOwner ||
                        $store.getters.isHRManager
                      "
                    >
                      <v-btn
                        title="Remove User From Organization"
                        v-if="
                          (!orgMember.isSuperAdmin &&
                            !orgMember.isOrgAdmin &&
                            orgMember.nameidentifier !==
                              ($store.state.userSelf.profile || {})
                                .nameidentifier) ||
                          (!orgMember.isParentOrg &&
                            !isCurrentOrg(orgMember.subdomain)) ||
                          $store.getters.isSuperAdmin
                        "
                        icon
                        @click.stop="
                          userToRemoveFromOrg = orgMember;
                          fetchUserDataForRemoval(orgMember.nameidentifier);
                          confirmDeleteDialog = true;
                        "
                      >
                        <v-icon color="red">mdi-minus-circle</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </template>
                </v-list-tile>
                <!-- <v-divider
                v-if="index + 1 < filteredItems.length"
                :key="index + 1 + filteredItems.length"
              ></v-divider> -->
              </v-card>
            </v-flex>
          </v-list>
          <!-- <v-flex class="text-xs-center" mt-3 v-if="filteredItems.length > 0">
            <v-pagination v-model="page" :length="pagerCount"></v-pagination>
          </v-flex> -->
          <v-flex class="text-xs-right" mt-3 v-if="orgMembers.length > 0">
            <div v-if="$store.getters.userIsAdministrativeOrOrgOwner">
              <span class="caption"
                ><v-icon color="success">mdi-home-lock</v-icon> Org Admin</span
              >
              <span class="caption"
                ><v-icon color="primary">mdi-home-account</v-icon> Org
                Owner</span
              >
              <span class="caption"
                ><v-icon color="indigo">mdi-account</v-icon> HR Manager</span
              >
              <span class="caption"
                ><v-icon color="secondary lighten-2">mdi-home-plus</v-icon> Add
                Org Owner</span
              >
              <span class="caption"
                ><v-icon color="red">mdi-home-minus</v-icon> Remove Org
                Owner</span
              >
              <span
                class="caption"
                v-if="
                  ($store.getters.userIsAdministrative ||
                    $store.getters.isOrgAdmin) &&
                  !$store.getters.isCurrentOrgChild
                "
                ><v-icon color="indigo">mdi-account-plus</v-icon> Add HR
                Manager</span
              >
              <span
                class="caption"
                v-if="
                  ($store.getters.userIsAdministrative ||
                    $store.getters.isOrgAdmin) &&
                  !$store.getters.isCurrentOrgChild
                "
                ><v-icon color="red">mdi-account-minus</v-icon> Remove HR
                Manager</span
              >
              <span class="caption"
                ><v-icon color="red">mdi-minus-circle</v-icon> Remove User</span
              >
            </div>
            <div v-else>
              <span class="caption"
                ><v-icon color="success">mdi-home-lock</v-icon> Org Admin</span
              >
              <span class="caption"
                ><v-icon color="primary">mdi-home-account</v-icon> Org
                Owner</span
              >
              <span class="caption"
                ><v-icon color="indigo">mdi-account</v-icon> HR Manager</span
              >
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-dialog v-model="confirmDeleteDialog" overlay persistent max-width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Remove Member from Organization</v-card-title
        >
        <v-card-text>
          <div>
            Are you sure you want to remove
            <span class="red-text"
              >'{{
                userToRemoveFromOrg
                  ? userToRemoveFromOrg.firstname +
                    " " +
                    userToRemoveFromOrg.lastname
                  : "the member"
              }}'</span
            >
            from the current Organization?
          </div>

          <div
            class="mt-2"
            v-if="
              userToRemoveFromOrg &&
              userToRemoveFromOrg.isParentOrg &&
              userToRemoveFromOrg.totalOvations > 0
            "
          >
            <v-checkbox
              color="#d13b55"
              hint="If selected, then we refund member's remaining ovations to parent-org."
              persistent-hint
              v-model="refundOvations"
              :label="
                'Also Refund ' + userToRemoveFromOrg.totalOvations + ' Ovations'
              "
            ></v-checkbox>
          </div>

          <div
            class="mt-4"
            v-if="userToRemoveFromOrg && userToRemoveFromOrg.isParentOrg"
          >
            <div v-if="fetchingUserDataForRemoval">
              <div class="caption">
                Fetching related data for removal, please wait...
              </div>
              <v-progress-linear
                color="#d13b55"
                height="2"
                :indeterminate="true"
              ></v-progress-linear>
            </div>

            <div
              v-if="
                !fetchingUserDataForRemoval &&
                userOwnedBountiesForRemoval &&
                userOwnedBountiesForRemoval.length > 0
              "
            >
              <v-layout row wrap align-center>
                <v-flex>
                  User has owned
                  <strong>{{ userOwnedBountiesForRemoval.length }}</strong>
                  {{
                    userOwnedBountiesForRemoval.length == 1
                      ? "Bounty, "
                      : "Bounties, "
                  }}

                  change Bounty owner to:
                </v-flex>
                <v-flex>
                  <v-select
                    dense
                    outline
                    single-line
                    hide-details
                    :items="orgMembers"
                    :loading="changingBountyOwner"
                    label="Select a new owner"
                    item-text="firstname"
                    item-value="nameidentifier"
                    v-model="selectedBountyOwner"
                    @change="onChangeBountyOwner"
                    class="width-max-200px"
                  >
                    <template v-slot:progress>
                      <v-progress-linear
                        color="#d13b55"
                        height="2"
                        indeterminate
                      ></v-progress-linear>
                    </template>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.firstname }} {{ data.item.lastname }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.firstname }} {{ data.item.lastname }}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </div>

            <div
              class="mt-2"
              v-if="
                !fetchingUserDataForRemoval &&
                userSignupBountiesForRemoval &&
                userSignupBountiesForRemoval.length > 0
              "
            >
              <v-layout row wrap align-center>
                <v-flex>
                  User has signed-up for
                  <strong>{{ userSignupBountiesForRemoval.length }}</strong>
                  {{
                    userSignupBountiesForRemoval.length == 1
                      ? "Bounty, "
                      : "Bounties, "
                  }}

                  sign out user?
                </v-flex>
                <v-flex>
                  <v-btn
                    class="btn-rounded-medium"
                    color="#d13b55"
                    small
                    outline
                    :loading="signoutUserLoading"
                    @click="
                      signoutUserFromBounty(userToRemoveFromOrg.nameidentifier)
                    "
                    >Signout User</v-btn
                  >
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="btn-rounded-medium"
            color="secondary"
            outline
            @click="confirmDeleteDialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            :disabled="
              fetchingUserDataForRemoval ||
              signoutUserLoading ||
              changingBountyOwner
            "
            class="btn-rounded-medium"
            color="#d13b55"
            outline
            @click="removeUserFromOrg()"
            >Remove</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import validationRules from "@/js/validationRules.js";

export default {
  name: "MembersListComponent",
  data() {
    return {
      isLoading: true,
      orgMembers: [],
      confirmDeleteDialog: false,
      userToRemoveFromOrg: null,
      requiredRules: validationRules.requiredRules,
      dateMenu: [],
      maxAllowedDate: new Date().toISOString().substr(0, 10),
      search: "",
      searchItems: [],
      page: 1,
      perPage: 10,
      refundOvations: true,
      fetchingUserDataForRemoval: false,
      signoutUserLoading: false,
      changingBountyOwner: false,
      userSignupBountiesForRemoval: [],
      userOwnedBountiesForRemoval: [],
      selectedBountyOwner: null,
      countryList: [
        { text: "Australia", value: "AU" },
        { text: "Canada", value: "CA" },
        { text: "France", value: "FR" },
        { text: "Germany", value: "DE" },
        { text: "India", value: "IN" },
        { text: "Singapore", value: "SG" },
        { text: "UAE", value: "AE" },
        { text: "UK", value: "GB" },
        { text: "USA", value: "US" },
      ],
    };
  },
  computed: {
    isHRManagerSet: function () {
      return (this.orgMembers || []).some(
        (record) => record.isHRManager == true
      );
    },
    pagerCount() {
      if (this.search) {
        return Math.ceil(this.filteredItems.length / this.perPage);
      }
      return Math.ceil(this.searchItems.length / this.perPage);
    },
    filteredItems() {
      return this.searchItems.filter((item) => {
        return (
          item.email.toLowerCase().includes(this.search.toLowerCase()) ||
          item.orgName.toLowerCase().includes(this.search.toLowerCase()) ||
          item.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
          item.lastname.toLowerCase().includes(this.search.toLowerCase()) ||
          (
            item.firstname.toLowerCase() +
            " " +
            item.lastname.toLowerCase()
          ).includes(this.search.toLowerCase())
        );
      });
      //.slice((this.page - 1) * this.perPage, this.page * this.perPage);
    },
  },
  methods: {
    loadMemberList: function () {
      var apiUrl = "/api/org/member/all/0";
      if (
        this.$store.getters.userIsAdministrative ||
        this.$store.getters.isOrgAdmin ||
        this.$store.getters.isHRManager
      ) {
        apiUrl = "/api/org/member/all/1";
      }
      this.isLoading = true;
      this.orgMembers = [];
      axios
        .get(apiUrl, this.$store.state.axiosConfig)
        .then((response) => {
          this.orgMembers = response.data;
          this.searchItems = this.orgMembers;
          this.isLoading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization team member list NOT retrieved.<br><strong>" +
              e.response.data.message +
              "</strong><br>Error #HLI983",
            messageType: "error",
          });

          this.isLoading = false;
        });
    },
    changeOrgOwnerStatus: function (orgMember, status) {
      // Display Message
      const msgStatus = status ? "Adding" : "Removing";
      this.$store.commit("replaceSnackbar", {
        message: `${msgStatus} Org Owner Status to member ${orgMember.firstname} ${orgMember.lastname} ...`,
        messageType: "warning",
      });

      const params = {
        nameidentifier: orgMember.nameidentifier,
        subdomain: orgMember.subdomain,
        isOwner: status,
      };
      this.isLoading = true;
      axios
        .post("/api/org/owner/status", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Display Success message
          const msgStatus = status ? "Added" : "Removed";
          this.$store.commit("replaceSnackbar", {
            message: `Successfully ${msgStatus} Org Owner Status on member ${orgMember.firstname} ${orgMember.lastname}.`,
          });

          // update the list
          this.orgMembers = response.data.memberList;
          this.searchItems = this.orgMembers;
          this.isLoading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization owner status was NOT updated.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.isLoading = false;
        });
    },
    changeOrgHRManagerStatus: function (orgMember, status) {
      // Display Message
      const msgStatus = status ? "Adding" : "Removing";
      this.$store.commit("replaceSnackbar", {
        message: `${msgStatus} HR Manager Status on member ${orgMember.firstname} ${orgMember.lastname} ...`,
        messageType: "warning",
      });

      const params = {
        nameidentifier: orgMember.nameidentifier,
        subdomain: orgMember.subdomain,
        isHRManager: status,
      };

      this.isLoading = true;
      axios
        .post("/api/org/hr/status", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Display Success message
          const msgStatus = status ? "Added" : "Removed";
          this.$store.commit("replaceSnackbar", {
            message: `Successfully ${msgStatus} HR Manager Status on member ${orgMember.firstname} ${orgMember.lastname}.`,
          });

          // Commit user info to global
          this.$store.commit("setUserSelf", response.data.user);
          // update the list
          this.orgMembers = response.data.memberList;
          this.searchItems = this.orgMembers;
          this.isLoading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization HR Manager status was NOT updated.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.isLoading = false;
        });
    },
    removeUserFromOrg: function () {
      // Stop if user has additonal data to be removed
      if (
        this.userOwnedBountiesForRemoval &&
        this.userOwnedBountiesForRemoval.length > 0
      ) {
        this.$store.commit("replaceSnackbar", {
          message: "Please change all bounties ownership before removing user.",
          messageType: "warning",
        });
        return;
      }

      if (
        this.userSignupBountiesForRemoval &&
        this.userSignupBountiesForRemoval.length > 0
      ) {
        this.$store.commit("replaceSnackbar", {
          message: "Please remove all bounties signups before removing user.",
          messageType: "warning",
        });
        return;
      }

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Removing user from organization...",
        messageType: "warning",
      });

      const params = {
        nameidentifier: this.userToRemoveFromOrg.nameidentifier,
        firstname: this.userToRemoveFromOrg.firstname,
        lastname: this.userToRemoveFromOrg.lastname,
        email: this.userToRemoveFromOrg.email,
        subdomain: this.userToRemoveFromOrg.subdomain,
        isParentOrg: this.userToRemoveFromOrg.isParentOrg,
        refundOvations:
          this.refundOvations &&
          this.userToRemoveFromOrg.isParentOrg &&
          this.userToRemoveFromOrg.totalOvations > 0,
      };
      this.isLoading = true;
      axios
        .post("/api/org/member/remove", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "User has been removed from the organization successfully",
          });

          // update the list
          this.orgMembers = response.data.memberList;
          this.searchItems = this.orgMembers;

          // Commit returned/received user info to global
          if (response.data.self)
            this.$store.commit("setUserSelf", response.data.self);

          this.isLoading = false;
          this.confirmDeleteDialog = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization member was NOT removed.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.isLoading = false;
          this.confirmDeleteDialog = false;
        });
    },
    saveMemberBirthDate: function (memberData) {
      // parse/validate birth date here
      if (memberData.dateofbirth.length > 5) {
        this.$store.commit("replaceSnackbar", {
          message:
            "Invalid Date of Birth, Enter date in MM/DD format without YEAR",
          messageType: "warning",
        });
        return false;
      }

      var bdIsValid = moment(
        memberData.dateofbirth,
        ["MM/DD", "M/D"],
        true
      ).isValid();

      if (!bdIsValid) {
        this.$store.commit("replaceSnackbar", {
          message:
            "Invalid Date of Birth, Enter date in MM/DD format without YEAR",
          messageType: "warning",
        });
        return false;
      }

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Saving member birth date...",
        messageType: "warning",
      });

      this.isLoading = true;
      axios
        .post(
          "/api/org/hr/member/birthdate",
          memberData,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Member Birth Date has been saved",
          });

          this.isLoading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Member Birth Date was NOT saved.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.isLoading = false;
        });
    },
    saveMemberStartDate: function (memberData) {
      if (memberData.startdate) {
        var sdIsValid = moment(
          memberData.startdate,
          ["MM/DD/YYYY", "M/D/YYYY"],
          true
        ).isValid();

        if (!sdIsValid) {
          this.$store.commit("replaceSnackbar", {
            message: "Invalid Start Date, Enter date in MM/DD/YYYY format",
            messageType: "warning",
          });
          return false;
        }
      }

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Saving member start date...",
        messageType: "warning",
      });

      this.isLoading = true;
      axios
        .post(
          "/api/org/hr/member/startdate",
          memberData,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Member Start Date has been saved",
          });

          this.isLoading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Member Start Date was NOT saved.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.isLoading = false;
        });
    },
    saveMemberCountry: function (memberData) {
      // validate country here
      if (memberData.country === "") {
        this.$store.commit("replaceSnackbar", {
          message: "Please select member country",
          messageType: "warning",
        });
        return false;
      }

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Saving member country...",
        messageType: "warning",
      });

      this.isLoading = true;
      axios
        .post(
          "/api/org/hr/member/country",
          memberData,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Member Country has been saved",
          });

          this.isLoading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Member Country was NOT saved.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.isLoading = false;
        });
    },
    clearSearch() {
      this.search = "";
    },
    isCurrentOrg: function (subdomain) {
      return (
        subdomain ==
        ((this.$store.state.userSelf.currentOrg || {}).org || {}).subdomain
      );
    },
    fetchUserDataForRemoval: function (userId) {
      if (
        userId === undefined ||
        userId === "" ||
        !this.userToRemoveFromOrg.isParentOrg
      )
        return;

      this.userSignupBountiesForRemoval = [];
      this.userOwnedBountiesForRemoval = [];
      this.fetchingUserDataForRemoval = true;

      axios
        .get(
          "/api/bounty/user/list/" +
            this.$store.getters.getParentOrgIdentifier +
            "/" +
            userId,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.userSignupBountiesForRemoval = response.data.signupBounties;
          this.userOwnedBountiesForRemoval = response.data.ownedBounties;
          this.fetchingUserDataForRemoval = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error while loading user's other data for removal.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.fetchingUserDataForRemoval = false;
        });
    },
    signoutUserFromBounty: function (userId) {
      if (userId === undefined || userId === "") return;

      this.signoutUserLoading = true;

      axios
        .post(
          "/api/bounty/signout/" +
            this.$store.getters.getParentOrgIdentifier +
            "/" +
            userId,
          {},
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.signoutUserLoading = false;
          this.fetchUserDataForRemoval(userId);
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error while sign-out user from bounty.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.signoutUserLoading = false;
        });
    },
    onChangeBountyOwner: function () {
      if (!this.userToRemoveFromOrg || !this.selectedBountyOwner) return;

      if (
        this.userToRemoveFromOrg.nameidentifier === this.selectedBountyOwner
      ) {
        this.$store.commit("replaceSnackbar", {
          message: "Please select a different user",
          messageType: "warning",
        });
        return;
      }

      this.changingBountyOwner = true;

      axios
        .post(
          "/api/bounty/user/owner/" +
            this.$store.getters.getParentOrgIdentifier +
            "/" +
            this.userToRemoveFromOrg.nameidentifier +
            "/" +
            this.selectedBountyOwner,
          {},
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.changingBountyOwner = false;
          this.selectedBountyOwner = null;
          this.fetchUserDataForRemoval(this.userToRemoveFromOrg.nameidentifier);
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error while changing bounty owner.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.changingBountyOwner = false;
        });
    },
  },
  beforeMount() {
    this.loadMemberList();
  },
  mounted() {
    this.searchItems = this.orgMembers;
  },
};
</script>
